<template>
  <div class="delivery-location">
    <div @click="openLocationModal" class="delivery-location__city">
      <svg class="delivery-location__city-decor delivery-location__decor" width="14" height="14"
           viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_3673_331)">
          <path d="M4.95978 0.412445C6.9796 -0.417477 9.28623 0.0504242 10.8133 1.60287C11.8499 2.62408 12.3748 4.0339 12.3748 5.46225C12.3748 6.53869 12.0094 7.60174 11.5203 8.55112C11.0293 9.50421 10.3966 10.3756 9.82306 11.0765L9.82013 11.0814C9.07069 11.9773 8.25061 12.8461 7.36017 13.6185L7.01642 13.9173L6.67169 13.6185C5.78631 12.8504 4.93457 11.9828 4.18048 11.0814L4.17657 11.0765C3.60182 10.3741 2.96988 9.49487 2.47931 8.53842C1.99108 7.58653 1.62482 6.52315 1.62482 5.46225C1.62491 3.2689 2.93063 1.24626 4.95978 0.412445ZM10.0672 2.34213C8.84106 1.09348 6.98754 0.715123 5.35919 1.38412C3.73879 2.04997 2.67471 3.67827 2.67462 5.46225C2.67462 6.29214 2.96483 7.18522 3.4129 8.05893C3.85823 8.92718 4.44192 9.74303 4.98712 10.4095C5.60662 11.1499 6.29676 11.8666 7.01544 12.5189C7.72378 11.8701 8.38959 11.154 9.01251 10.4095C9.55898 9.7415 10.1428 8.93419 10.5877 8.07065C11.0349 7.20256 11.325 6.3092 11.325 5.46225C11.325 4.28416 10.8919 3.15215 10.074 2.34799L10.0672 2.34213ZM7.01642 2.26401C8.7296 2.26424 10.1023 3.67563 10.1024 5.39682C10.1024 7.11805 8.72963 8.5294 7.01642 8.52963C5.303 8.52963 3.9295 7.11819 3.9295 5.39682C3.92956 3.67549 5.30304 2.26401 7.01642 2.26401ZM7.01642 3.31381C5.90086 3.31381 4.98034 4.2373 4.98029 5.39682C4.98029 6.55639 5.90083 7.47983 7.01642 7.47983C8.13181 7.47959 9.05255 6.55624 9.05255 5.39682C9.0525 4.23745 8.13178 3.31405 7.01642 3.31381Z" fill="white"/>
        </g>
        <defs>
          <clipPath id="clip0_3673_331">
            <rect width="14" height="14" fill="white"/>
          </clipPath>
        </defs>
      </svg>
      <span class="delivery-location__city-title">{{ userCityName }}</span>
      <svg class="delivery-location__city-arrow" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M17 14.2941L16.2933 15L11.7 10.4118L7.10667 15L6.4 14.2941L11.7 9L17 14.2941Z" fill="#909090"/>
      </svg>
    </div>
    <div v-if="storesInCity && storesInCity.length > 0" class="delivery-location__dropdown">
      <div @click="openStoresModal" class="delivery-location__store">
        <svg class="delivery-location__store-decor delivery-location__decor" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12.285 2.37292V2.58972C12.285 3.3008 11.9544 3.90941 11.4452 4.31824V6.08875C12.925 6.7059 13.9647 8.16656 13.9647 9.87C13.9647 12.1316 12.1316 13.9647 9.87 13.9647C8.13986 13.9647 6.66123 12.8917 6.0614 11.3749H0.804565V4.26746C0.327574 3.84218 0.0350342 3.23494 0.0350342 2.58972V2.37292L2.37292 0.0350342H9.94714L12.285 2.37292ZM9.87 6.82507C8.18829 6.82508 6.82508 8.18829 6.82507 9.87C6.82507 11.5517 8.18829 12.9149 9.87 12.9149C11.5517 12.9149 12.9149 11.5517 12.9149 9.87C12.9149 8.18829 11.5517 6.82507 9.87 6.82507ZM10.4647 9.27527H11.83V10.3251H10.4647V11.6903H9.41492V10.3251H8.04968V9.27527H9.41492V7.91003H10.4647V9.27527ZM7.99109 3.99695C7.54328 4.53252 6.84926 4.86511 6.08972 4.86511C5.33672 4.86501 4.68993 4.52499 4.26746 4.01453C3.81919 4.54008 3.13123 4.86511 2.37976 4.86511C2.19805 4.86509 2.02306 4.84273 1.85535 4.80554V10.3251H5.80066C5.78413 10.1756 5.77527 10.0238 5.77527 9.87C5.77527 7.60839 7.60839 5.77527 9.87 5.77527C10.0481 5.77527 10.2233 5.78741 10.3954 5.80945V4.80945C10.2253 4.8447 10.0496 4.86511 9.87 4.86511C9.11835 4.8651 8.43719 4.52056 7.99109 3.99695ZM1.10339 2.78894C1.20305 3.33308 1.70176 3.81518 2.37976 3.81531C3.18017 3.81531 3.745 3.241 3.745 2.58972H4.7948C4.7948 3.20968 5.32986 3.81512 6.08972 3.81531C6.89013 3.81531 7.45496 3.241 7.45496 2.58972H8.50476C8.50476 3.18406 9.08358 3.81529 9.87 3.81531C10.5873 3.81531 11.1158 3.35435 11.2177 2.78992L9.51257 1.08484H2.8075L1.10339 2.78894Z" fill="#333333"/>
        </svg>
        <span class="delivery-location__store-title">{{ userStoreName }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { formattedDeliveryInfo } from '@/mixins'

export default {
  name: 'DeliveryLocation',
  mixins: [formattedDeliveryInfo],
  computed: {
    ...mapState({
      userCity: state => state.geoLocation.userCity,
      userStore: state => state.geoLocation.userStore,
      storesInCity: state => state.geoLocation.storesInCity
    }),
    userCityName () {
      return this.userCity?.name || this.$t('delivery-store-balance.not-choose')
    },
    userStoreName () {
      return this.userStore?.name || this.$t('delivery-store-balance.not-choose')
    }
  },
  methods: {
    openLocationModal () {
      this.$modal.show('city-location-modal')
    },
    openStoresModal () {
      this.$modal.show('map-modal', {
        spots: this.formatDeliverySpotsInfo(this.storesInCity.map(el => {
          return {
            ...el,
            quantity: 20
          }
        }), 'chooseStore'),
        mailName: 'chooseStore',
        withoutAddToCart: true,
        title: this.$t('reserve_map_title')
      })
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (!this.userCity?.name || !this.userCity?.is_selected) {
        this.$modal.show('city-location-modal')
      }
    })
  }
}
</script>

<style lang="sass" scoped>
.delivery-location
  position: relative
  z-index: 5
  padding: 6px 8px
  border-radius: 3px
  cursor: pointer
  background-color: #424242
  color: #fff
  transition: all 0.2s
  box-shadow: 0 5px 4px rgba(0, 0, 0, 0)
  margin-bottom: 1px
  margin-left: 40px
  &:hover
    background-color: #fff
    color: #333333
    border-bottom-left-radius: 0
    border-bottom-right-radius: 0
    box-shadow: 0 5px 4px rgba(0, 0, 0, 0.25)
    .delivery-location__decor
      path
        fill: #333
    .delivery-location__city-arrow
      transform: rotate(0)
    .delivery-location__dropdown
      opacity: 1
      pointer-events: all
      box-shadow: 0 5px 4px rgba(0, 0, 0, 0.25)
  &__decor
    width: 14px
    height: 14px
    flex-shrink: 0
    margin-right: 8px
    path
      transition: fill 0.2s
  &__city
    display: flex
    align-items: center
    min-width: 144px
    &-title
      font-size: 14px
      font-weight: 500
      margin-right: 5px
      line-height: 18px
      color: inherit
      transition: color 0.2s
    &-arrow
      margin-left: auto
      transform: rotate(180deg)
      transition: transform 0.2s
  &__store
    display: flex
    align-items: center
    &-title
      font-size: 14px
      font-weight: 500
      line-height: 18px
      margin-right: 5px
      color: #333
  &__dropdown
    position: absolute
    left: 0
    top: 100%
    width: 100%
    background-color: #fff
    opacity: 0
    pointer-events: none
    transition: all 0.2s
    z-index: 2
    padding: 8px 8px 6px 8px
    border-bottom-left-radius: 3px
    border-bottom-right-radius: 3px
    box-shadow: 0 5px 4px rgba(0, 0, 0, 0)
    &:after
      content: ''
      position: absolute
      left: 8px
      top: 0
</style>
